import tw, { styled } from 'twin.macro';

export const StyledForm = styled.form`
  ${tw`flex flex-col gap-2`}
`;
